<template>
  <div
    class="align-center background-color-white d-flex flex-column pb-5 pt-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold text-center">
      Welcome to {{ wait(storeInfo, "name") }}
    </div>
    <div class="mb-5">Log in with your Phone Number</div>
    <v-form
      ref="form"
      v-model="valid"
      class="full-width"
      @submit.prevent="toConfirmation"
    >
      <PhoneInput :phone="phone" :updatePhone="updatePhone" autofocus />
      <p>
        We will send you a
        <span class="font-weight-semibold">confirmation code</span> to this
        number.
      </p>
      <v-btn
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          continue
        </div>
      </v-btn>
    </v-form>
    <OrDivider />

    <div class="d-flex full-width justify-space-between mb-4">
      <button @click="toLogInRoute($options.Views.email)">
        <span class="font-weight-semibold outline-none primary--text"
          >Log in with Email</span
        >
      </button>
      <button @click="toAuthRoute('signup')">
        <span class="font-weight-semibold outline-none primary--text"
          >Sign Up</span
        >
      </button>
    </div>
    <div class="full-width">
      <button class="mb-2" @click="toAuthRoute('request')">
        Forgot your password?
        <span class="font-weight-semibold outline-none primary--text"
          >Reset it</span
        >.
      </button>
    </div>
    <div
      class="color-suva-grey font-weight-semibold text-center"
      :class="$vuetify.breakpoint.xsOnly ? 'font-size-xxs' : 'font-size-sm'"
    >
      By tapping the Log In or Sign Up buttons you agree to our:
    </div>
    <LegalLinks :closeAuth="closeAuth" />
  </div>
</template>

<script>
import { Views } from "@/types/login.js";
import { mapState } from "vuex";
import { wait } from "@/util.js";
import PhoneInput from "@/components/Inputs/Phone.vue";
import LegalLinks from "@/components/Auth/LogIn/LegalLinks.vue";
import OrDivider from "@/components/Auth/LogIn/OrDivider.vue";

export default {
  name: "PhoneLogInContent",
  components: {
    LegalLinks,
    OrDivider,
    PhoneInput,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      email: null,
      password: null,
      valid: true,
    };
  },
  methods: {
    toConfirmation() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.$store.dispatch("auth/sendVerificationCodeToPhone", {
        country_code: 1,
        phone_number: this.phone,
      });
      this.toLogInRoute(Views.sms);
    },
    wait,
  },
  props: {
    closeAuth: Function,
    phone: String,
    toAuthRoute: Function,
    toLogInRoute: Function,
    updatePhone: Function,
  },
  Views,
};
</script>
